if (!customElements.get('ugc-gallery')) {
  customElements.define(
    'ugc-gallery',
    class UgcGallery extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('.bearpaw-ugc__lightbox');
        if (!this.dialog) return;
        this.track = this.dialog.querySelector('.bearpaw-ugc__lb-track');
        this.current = this.dialog.querySelector('.bearpaw-ugc__lb-current');
        this.prev = this.dialog.querySelector('[data-ugc-prev]');
        this.next = this.dialog.querySelector('[data-ugc-next]');

        this.addEventListener('click', this);
        this.dialog.addEventListener('keydown', this);
        this.dialog.addEventListener('close', this);
        this.track.addEventListener('scroll', this, { passive: true });
      }

      handleEvent(event) {
        switch (event.type) {
          case 'scroll':
            return this.update();
          case 'close':
            document.documentElement.classList.remove('bearpaw-ugc-locked');
            return this.trigger?.focus();
          case 'keydown':
            if (event.key === 'ArrowRight') this.step(1);
            else if (event.key === 'ArrowLeft') this.step(-1);
            else return;
            return event.preventDefault();
        }

        const target = event.target;
        const opener = target.closest('[data-ugc-index]');
        if (opener) return this.open(Number(opener.dataset.ugcIndex), opener);
        if (target.closest('[data-ugc-close]')) return this.dialog.close();
        if (target.closest('[data-ugc-prev]')) return this.step(-1);
        if (target.closest('[data-ugc-next]')) return this.step(1);
        // A click on the empty area around the photo closes, like any lightbox.
        if (target === this.dialog || target.classList.contains('bearpaw-ugc__lb-slide')) this.dialog.close();
      }

      open(index, trigger) {
        this.trigger = trigger;
        document.documentElement.classList.add('bearpaw-ugc-locked');
        this.dialog.showModal();
        this.goTo(index, 'instant');
        this.update();
      }

      goTo(index, behavior) {
        this.preload(index);
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior });
      }

      // Lazy images in a dialog only start once laid out; kick off the target and its
      // neighbours right away so swiping doesn't land on an empty frame.
      preload(index) {
        for (const i of [index - 1, index, index + 1]) {
          const img = this.track.children[i]?.querySelector('img');
          if (img) img.loading = 'eager';
        }
      }

      step(direction) {
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.goTo(this.index() + direction, smooth ? 'smooth' : 'instant');
      }

      index() {
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      update() {
        const index = this.index();
        const last = this.track.children.length - 1;
        if (this.current) this.current.textContent = index + 1;
        if (this.prev) this.prev.disabled = index <= 0;
        if (this.next) this.next.disabled = index >= last;
      }
    }
  );
}
